/**
 * Index Component
 *
 * This component serves as the main container for the partial cancellation page.
 * It handles the routing and rendering of different cancellation services (Excursion and Seat Reservation).
 *
 * @component
 * @extends {Component}
 */

// Externe Bibliotheken
import React, { Component } from 'react';
import { Navigate } from 'react-router';
import axios from 'axios';

// Interne Module
import partialCancellationConfig from '@/_config/partial-cancellation';
import { withRouter } from '@/_helper/withRouter';
import tracking from '@/_helper/tracking';
import * as storage from '@/_helper/storage';
import contentPartialCancellation from '@/_data/contentPartialCancellation';

// Komponenten
import Header from '@/comp/header/Header';
import Footer from '@/comp/footer/Footer';
import Excursion from './excursion';
import SeatReservation from './seat-reservation';
import StatusPage from '@/comp/statusPage/statusPage';

class Index extends Component {
    constructor(props) {
        super(props);

        this.state = {
            service: this.reformatServiceTitle(props.params?.service),
            bookingData: storage.get('bookingData') ?? {},
            cancellationData: storage.get('cancellationData') ?? null,
            pageState: 'initial',
            access: {
                state: true,
                redirectTo: this,
            },
        };
    }

    /**
     * Checks if the cancellation service is allowed
     * @param {string} service - The service to check
     */
    checkIsAllowToCancellationService(service) {
        let mapServiceByTitle = null;
        Object.entries(contentPartialCancellation).filter(function (extra) {
            if (extra[1]?.title.toLowerCase() === service.toLowerCase()) {
                mapServiceByTitle = extra[0];
            }
        });

        if (service === undefined || partialCancellationConfig?.allowToCancellationService === undefined) {
            this.setState({
                access: {
                    state: false,
                    redirectTo: '/',
                },
            });
        } else if (
            partialCancellationConfig?.allowToCancellationService.includes(service) &&
            this.state?.bookingData.data?.allowedInteractions?.cancellation?.partialCancellation[mapServiceByTitle]
        ) {
            if (this.state.service === 'Ausflug') {
                tracking('loaded', 'partialCancellationExcursion');
            }
            if (this.state.service === 'Sitzplatzreservierung') {
                tracking('loaded', 'partialCancellationSeatReservation');
            }
        } else {
            this.setState({
                access: {
                    state: false,
                    redirectTo: '/stornierungsoptionen',
                },
            });
        }
    }

    /**
     * Reformats the service title
     * @param {string} val - The value to reformat
     * @returns {string} The reformatted title
     */
    reformatServiceTitle(val) {
        return val ? val.charAt(0).toUpperCase() + val.slice(1) : '';
    }

    componentDidMount() {
        document.title = `${this.state.service ? this.state.service + ' |' : ''} Stornierung ${window.$documentTitle}`;
        document.querySelector('html').classList.add('redesign');

        this.state.cancellationData === null && this.getCancellationData();
        this.checkIsAllowToCancellationService(this.state?.service.toLowerCase());
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.params?.service !== this.props.params?.service) {
            this.setState({
                service: this.reformatServiceTitle(this.props.params?.service),
            });

            if (this.props.params?.service) {
                this.checkIsAllowToCancellationService(this.props.params?.service.toLowerCase());
            }
        }
    }

    getCancellationData() {
        this.setState({ pageState: 'loading' });

        const bookingId = storage.get('bookingNumber') ?? '';

        axios({
            url:
                window.$serviceUrl +
                '/cancellationcosts?token=' +
                window.$token +
                '&bookingId=' +
                bookingId +
                '&clientId=customerarea',
            method: 'GET',
        })
            .then((response) => response)
            .then((data) => {
                const cancellationData = data?.data?.data?.paymentCancellationPolicy?.servicesCustomer;

                if (!cancellationData) {
                    throw new Error('no cancellation data found');
                }
                storage.set('cancellationData', cancellationData);

                this.setState({
                    pageState: 'loaded',
                    cancellationData: cancellationData,
                });
            })
            .catch(() => {
                this.setState({ pageState: 'error' });
            });
    }

    render() {
        let { service, access } = this.state;

        let serviceComp, statusSubPage;
        switch (service) {
            case 'Ausflug':
                serviceComp = (
                    <Excursion
                        pageState={this.state.pageState}
                        bookingData={this.state.bookingData}
                        cancellationData={this.state.cancellationData}
                    />
                );
                statusSubPage = 'partialCancellationExcursion';
                break;
            case 'Sitzplatzreservierung':
                serviceComp = (
                    <SeatReservation
                        pageState={this.state.pageState}
                        bookingData={this.state.bookingData}
                        cancellationData={this.state.cancellationData?.seatReservation}
                    />
                );
                statusSubPage = 'partialCancellationSeatReservation';
                break;
            default:
                break;
        }

        return access?.state ? (
            <div className={`page-partial-cancellation ${service && service.toLowerCase()}`}>
                <Header />
                {this.state.pageState === 'error' ? <StatusPage type="error" subPage={statusSubPage} /> : serviceComp}
                <Footer />
            </div>
        ) : (
            <Navigate to={access.redirectTo} replace />
        );
    }
}

export default withRouter(Index);
